/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type PublishPluginsRequestBody = {
  /**
   * GitHub usernames to add as collaborators on the repo.
   */
  githubUsernames?: Array<string> | undefined;
};

/** @internal */
export type PublishPluginsRequestBody$Outbound = {
  github_usernames?: Array<string> | undefined;
};

/** @internal */
export const PublishPluginsRequestBody$outboundSchema: z.ZodMiniType<
  PublishPluginsRequestBody$Outbound,
  PublishPluginsRequestBody
> = z.pipe(
  z.object({
    githubUsernames: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      githubUsernames: "github_usernames",
    });
  }),
);

export function publishPluginsRequestBodyToJSON(
  publishPluginsRequestBody: PublishPluginsRequestBody,
): string {
  return JSON.stringify(
    PublishPluginsRequestBody$outboundSchema.parse(publishPluginsRequestBody),
  );
}
